import './../App.css';
import '../css/pages/entreprise.css';
import React, { useEffect, useState } from 'react';
import { FooterComponent, FooterMainComponent } from '../components/MainComponents';
import bg from '../img/section-bg-2.png';
import { Link, NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function Entreprise() {


    const [mobilenav, setMobilenav] = useState(false)

    const backgroundStyle = {
        backgroundImage: `url(${bg})`,
    };

    function topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    useEffect(() => {
        global.globalType = "all";
        document.getElementById("entreprise").classList.add('onLinkFocus'); document.getElementById("competence").classList.remove('onLinkFocus'); document.getElementById("realisation").classList.remove('onLinkFocus'); document.getElementById("contact").classList.remove('onLinkFocus'); document.documentElement.scrollTop = 0
    }, [])

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 992) {
                setMobilenav(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);

    }, [window.innerWidth]);


    return (
        <div>
            <Helmet>
                <title>Décohome75 - Notre Histoire</title>
                <meta name="description" content="Décohome75 est une entreprise de rénovation intégrale pour maison basée à Paris, France, spécialisée dans les rénovations de salle de bain, cuisine, murs et sols. Nous proposons des services de maçonnerie, plomberie, menuiserie, peinture et plâtrerie, électricité générale, parqueterie et carrelage." />
        <meta name="keywords" content="rénovation, maison, rénovation intégrale, rénovation complète, salle de bain, cuisine, murs et sols, maçonnerie, plomberie, menuiserie, peinture et plâtrerie, électricité générale, parqueterie, carrelage" />
        <meta name="robots" content="index, follow" />
      </Helmet>

            {/* navbar */}

            <div class="home-navbar">
                    <div class="container mynavbar-container" >
                    <div class="">
                                <Link
                                    to="/"
                                    className="my-navbar-logo"
                                    onClick={() => topFunction()}
                                ><img src="../assets/images/logo-dark.png" alt="" /></Link>
                            </div>
                        <div className='mynvabar-links'>
                            <NavLink
                                to="/entreprise"
                                id="entreprise"
                                className = { ({isActive}) => isActive ? "my-navbar-link-active" : "my-navbar-link" }
                                onClick={() => topFunction()}
                            >
                                Qui sommes-nous
                            </NavLink>
                            <NavLink
                                to="/competence"
                                id="competence"
                                className = { ({isActive}) => isActive ? "my-navbar-link-active" : "my-navbar-link" }
                                onClick={() => topFunction()}
                            >
                                Compétences
                            </NavLink>
                            <NavLink
                                to="/realisation"
                                id="realisation"
                                className = { ({isActive}) => isActive ? "my-navbar-link-active" : "my-navbar-link" }
                                onClick={() => topFunction()}
                            >
                                Nos Réalisations
                            </NavLink>
                            <NavLink
                                to="/contact"
                                id="contact"
                                className = { ({isActive}) => isActive ? "my-navbar-link-active" : "my-navbar-link" }
                                onClick={() => topFunction()}
                            >
                                Devis et Contact
                            </NavLink>

                        </div>
                        <div className='mynavbar-icon' onClick={() => {setMobilenav(!mobilenav)}}>
                            <i class="fa fa-bars" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div className={`mynavbar-mobile-container ${mobilenav ? "mynavbar-mobile-container-visible" : ""}`}>
                    <div className='container mynavbar-links-mobile noPadding'>
                    <NavLink
                                to="/entreprise"
                                id="entreprise"
                                className = { ({isActive}) => isActive ? "my-navbar-link-active" : "my-navbar-link" }
                                onClick={() => topFunction()}
                            >
                                Qui sommes-nous
                            </NavLink>
                            <NavLink
                                to="/competence"
                                id="competence"
                                className = { ({isActive}) => isActive ? "my-navbar-link-active" : "my-navbar-link" }
                                onClick={() => topFunction()}
                            >
                                Compétences
                            </NavLink>
                            <NavLink
                                to="/realisation"
                                id="realisation"
                                className = { ({isActive}) => isActive ? "my-navbar-link-active" : "my-navbar-link" }
                                onClick={() => topFunction()}
                            >
                                Nos Réalisations
                            </NavLink>
                            <NavLink
                                to="/contact"
                                id="contact"
                                className = { ({isActive}) => isActive ? "my-navbar-link-active" : "my-navbar-link" }
                                onClick={() => topFunction()}
                            >
                                Devis et Contact
                            </NavLink>
                    </div>
                    </div>
                </div>

            {/* Notre histoire */}

            <section class="qsn-qsn-area" id="about" style={backgroundStyle}>
                <div class="homeqsnHeader container noPadding">

                    <div>
                        <div class="homeqsnTitle">
                            Notre histoire<span>.</span>
                        </div>
                        <h2 class="homeqsnDesc">Nous réalisons vos travaux de rénovation, en tous corps d&rsquo;état</h2>
                        <hr class="home-hr" ></hr>

                    </div>

                    <div class="">
                        <div class="homeqsnText">
                            Déco Home 75, entreprise générale du bâtiment basée à Paris réalise vos travaux de rénovation, en tous corps d’états. Notre métier est de vous accompagner dans tous vos projets de travaux, en vous proposant des interventions sur-mesure et un suivi à la hauteur de vos exigences. Déco Home 75 s'engage au bon déroulement de vos travaux, et vous assure un suivi personnalisé et hebdomadaire. Ce rendez-vous hebdomadaire sera l'occasion de vérifier point par point l'avancement de vos travaux et de répondre en temps réel au moindre questionnement. Parce ce qu'une rénovation de maison nécessite plusieurs corps de métier, notre équipe composée d'artisans experts couvrent les champs de compétence suivants: peinture, plâtrerie, salle de bain, cuisine, carrelage, parquet, menuiseries sur mesure, aménagement de comble, isolation intérieure, plomberie, électricité.Obtenez votre devis gratuit et sans engagement.
                        </div>

                    </div>
                </div>

            </section>

            <FooterMainComponent />
            <FooterComponent />

        </div >
    );
}


export default Entreprise;
